import { render, staticRenderFns } from "./settings-section.vue?vue&type=template&id=1293960c&scoped=true&"
import script from "./settings-section.vue?vue&type=script&lang=js&"
export * from "./settings-section.vue?vue&type=script&lang=js&"
import style0 from "./settings-section.vue?vue&type=style&index=0&id=1293960c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1293960c",
  null
  
)

export default component.exports